// extracted by css-extract-rspack-plugin
export default {"ticketIcon":"_CxsXqJdDns6aeju"};